import { render } from "./SectionContacts.vue?vue&type=template&id=24aa93b6&scoped=true"
import script from "./SectionContacts.vue?vue&type=script&lang=js"
export * from "./SectionContacts.vue?vue&type=script&lang=js"

import "./SectionContacts.vue?vue&type=style&index=0&id=24aa93b6&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aa93b6"]])

export default __exports__